import Footer from "./Footer";
import "./Footer.scss";

export default Footer;
